// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3S2pW","upload":"Small_upload__KufW-","imageWrap":"Small_imageWrap__sCF3k","removeBtn":"Small_removeBtn__3CPVM"};